import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { trocarIdioma } from '@/lib/i18n';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => trocarIdioma(i18n.language === 'pt-BR' ? 'en-US' : 'pt-BR')}
      className="w-full"
    >
      <Languages className="mr-2 h-4 w-4" />
      {i18n.language === 'pt-BR' ? '🇧🇷 Portugues' : '🇺🇸 English'}
    </Button>
  );
}
